import styled from 'styled-components';
import { Table } from 'antd';

interface TableWrapperProps {
  isSorter: boolean;
}

const TableWrapper = styled(Table)<TableWrapperProps>`
  &.table-wrapper {
    padding: 12px;
    background: ${({ theme }) => theme.background.content};
    border-radius: 8px;
  }

  .ant-table-pagination.ant-pagination {
    margin-top: 25px;
  }
  .ant-table-thead > tr:first-child > th {
    background: ${({ theme }) => theme.table.headerBackground};
    font-weight: 700;
  }
  .ant-table-scroll .ant-table-body {
    overflow-x: auto !important;
  }
  .ant-table-column-sorters {
    .ant-table-column-sorter {
      display: ${({ isSorter }) => (isSorter ? 'none' : 'initial')};
    }
    .icon-sorter {
      font-size: 20px;
    }
  }
  .ant-dropdown-trigger .anticon {
    font-size: 14px;
  }
  .ant-table-container .ant-table-sticky-scroll {
    display: none;
  }
`;

export default TableWrapper;
